<template>
    <div class="yk-upload-file-manager clearfix">
        <div class="top-page-top">
            <span class="sp-top-text">
                <span>考试相关网址</span>
            </span>
        </div>
        <el-form label-width="180px" :rules="rules" ref="ruleForm" :model="ruleForm" class="change-user-password-form">
            <!-- <el-form-item label="考务端地址">
                <el-input v-model="ruleForm.KWDUrl"></el-input>
            </el-form-item>
            <el-form-item label="考务端文档地址">
                <el-input v-model="ruleForm.KWWDUrl"></el-input>
            </el-form-item>
            <el-form-item label="管理端地址">
                <el-input v-model="ruleForm.GLDUrl"></el-input>
            </el-form-item>
            <el-form-item label="管理端文档地址">
                <el-input v-model="ruleForm.GLDWDUrl"></el-input>
            </el-form-item>
            <el-form-item label="学生端地址">
                <el-input v-model="ruleForm.XSDUrl"></el-input>
            </el-form-item>
            <el-form-item label="学生端文档地址">
                <el-input v-model="ruleForm.XSDWDUrl"></el-input>
            </el-form-item>
            <el-form-item label="手持端地址">
                <el-input v-model="ruleForm.SCDUrl"></el-input>
            </el-form-item>
            <el-form-item label="手持端文档地址">
                <el-input v-model="ruleForm.SCDWDUrl"></el-input>
            </el-form-item>
            <el-form-item label="管理规范地址">
                <el-input v-model="ruleForm.GLGFUrl"></el-input>
            </el-form-item>
            <el-form-item label="流程图地址">
                <el-input v-model="ruleForm.LCTUrl"></el-input>
            </el-form-item> -->
            <el-form-item label="考试端网址">
                <el-input v-model="ruleForm.ExamUrl"></el-input>
            </el-form-item>
            <el-form-item label="模拟系统网址">
                <el-input v-model="ruleForm.MockUrl"></el-input>
            </el-form-item>
            <el-form-item label="实时大屏网址">
                <el-input v-model="ruleForm.ScreenUrl"></el-input>
            </el-form-item>
            <el-form-item label="培训平台网址">
                <el-input v-model="ruleForm.PeixunUrl"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="save('ruleForm')">保存</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
export default {
    data() {
        return {
            ruleForm: {
                Id: "",
                KWDUrl: "",
                KWWDUrl: "",
                GLDUrl: "",
                GLDWDUrl: "",
                XSDUrl: "",
                XSDWDUrl: "",
                SCDUrl: "",
                SCDWDUrl: "",
                GLGFUrl: "",
                LCTUrl: "",
                ExamUrl:"",
                MockUrl:"",
                ScreenUrl:"",
                PeixunUrl:""
            },
            rules: {
                // KWDUrl: [{ required: true, message: "请输入", trigger: "blur" }],
                // KWWDUrl: [{ required: true, message: "请输入", trigger: "blur" }],
                // GLDUrl: [{ required: true, message: "请输入", trigger: "blur" }],
                // GLDWDUrl: [{ required: true, message: "请输入", trigger: "blur" }],
                // XSDUrl: [{ required: true, message: "请输入", trigger: "blur" }],
                // XSDWDUrl: [{ required: true, message: "请输入", trigger: "blur" }],
                // SCDUrl: [{ required: true, message: "请输入", trigger: "blur" }],
                // SCDWDUrl: [{ required: true, message: "请输入", trigger: "blur" }],
                // GLGFUrl: [{ required: true, message: "请输入", trigger: "blur" }],
                // LCTUrl: [{ required: true, message: "请输入", trigger: "blur" }],
            },
        };
    },
    created() {
        this.getFileUrlList();
    },
    props:{
        certificateId:{
            default:"",
            type:String
        }
    },
    methods: {
        save(formName) {
            
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    var that = this;
                    that.$http
                        .post("/api/XOrg/FileManager/addOrEditFileUrl", {
                            Id: that.ruleForm.Id,
                            KWDUrl: that.ruleForm.KWDUrl,
                            KWWDUrl: that.ruleForm.KWWDUrl,
                            GLDUrl: that.ruleForm.GLDUrl,
                            GLDWDUrl: that.ruleForm.GLDWDUrl,
                            XSDUrl: that.ruleForm.XSDUrl,
                            XSDWDUrl: that.ruleForm.XSDWDUrl,
                            SCDUrl: that.ruleForm.SCDUrl,
                            SCDWDUrl: that.ruleForm.SCDWDUrl,
                            GLGFUrl: that.ruleForm.GLGFUrl,
                            LCTUrl: that.ruleForm.LCTUrl,
                            ExamUrl:that.ruleForm.ExamUrl,
                            MockUrl:that.ruleForm.MockUrl,
                            ScreenUrl:that.ruleForm.ScreenUrl,
                            PeixunUrl:that.ruleForm.PeixunUrl,
                            certificateTypeId:this.certificateId
                        })
                        .then(function(rst) {
                            if (rst.code > 0) {
                                that.getFileUrlList();
                                that.$message.success(rst.msg);
                            } else {
                                that.$message.warning(rst.msg);
                            }
                        });
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        //查询
        getFileUrlList() {
            var that = this;
            this.$http.post("/api/XOrg/FileManager/getFileUrlList",{
                certificateTypeId:this.certificateId

            }).then(function(rst) {
                if (rst.code > 0 && rst.list != null) {
                    that.ruleForm = rst.list;
                } else {
                    that.$message.warning(rst.msg);
                }
            });
        },
    },
};
</script>

<style lang="scss">
.yk-upload-file-manager {
    background: #fff;
    padding-bottom: 20px;
    .change-user-password-form{
        width: 800px;
        margin-top: 30px;
    }
    .add-partner-enterprise-head {
        border-bottom: 1px solid #F0F0F0;
        height: 60px;
        .add-banner-btn,
        .delete-banner-btn {
            margin-top: 13px;
        }
        .delete-banner-btn {
            margin-right: 62px;
        }
        .top-page-top{
            border: none;
        }
    }
    .banner-page-con {
        padding: 20px 0;
        text-align: center;
    }
    .el-table thead{
        color: #05243D;
    }
    .btn-right{
        margin-top: 14px;
    }
    .export-button-a {
        color: #fff;
        background: #409eff;
        padding: 8px 15px;
        border-radius: 4px;
        margin: 0 10px;
    }
}
</style>
